export default __webpack_public_path__ + "static/terms-39f9c9c946b951354648930198b1903d.pdf";